import React, {Component} from "react";
import {connect} from "react-redux";

import GlobalLoader from "./ui/global-loader";
import {connectionEstablished, connectionLost, connectWsRpc} from "store/reducers/main";
import "./App.less";

@connect(state => ({
    isConnected: state.main.get('isConnected'),
}), {connectWsRpc, connectionLost, connectionEstablished})

export default class AppComponent extends Component {
    state = {
        websocketsActive: false,
    };

    componentWillMount() {
        localStorage.removeItem('user');
        if (!this.props.isConnected) {
            this.props.connectWsRpc();
        }
    }

    async componentDidMount() {
        this.listenWebsocketEvents();
    }

    render() {
        return this.props.children;
    }

    listenWebsocketEvents() {
        this.props.connectionLost(() => {
            this.setState({websocketsActive: false});
        });

        this.props.connectionEstablished(() => {
            this.setState({websocketsActive: true});
        });
    }
}



// WEBPACK FOOTER //
// ./src/components/App.js